import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';

import styles from './snapshot_item.css';
import { Icon } from '../../icon/icon';
import { InternalLink } from '../../internal_link/internal_link';

/**
 * Presentational component for a snapshot item
 * Can optionally include an icon and subtitle
 * @param {Object} props - component props
 * @returns {Node} - component
 * @constructor
 */
const SnapshotItem = (props) => {
    const { contentProps, visualProps } = props;
    const { title = false, value, separator, subHeading, link = false } = contentProps;
    const { icon } = visualProps;
    const valueClass = title && !link ? styles.value : styles.title;
    const key = `SnapshotItem.${title}.${value}`;
    const innerComponents = [<span key={`${key}.value`} className={valueClass}>{value}</span>];
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    const titleComponent = title ? (<label key={`${key}.label`} className={styles.label}>{`${title}${separator} `}</label>) : null;
    if (titleComponent) {
        innerComponents.unshift(titleComponent);
    }
    let linkComponent = null;
    let linkStyle = null;
    if (link) {
        const dataId = link.split('/').slice(-1).join('').split('?')[0];
        linkStyle = styles.container_with_link;
        innerComponents.unshift(<Icon key={`${key}.icon`} className={styles.edit_icon} variant="ctm_pencil" />);
        linkComponent = <InternalLink href={link} data-id={`SnapshotLink.${dataId}`}>{innerComponents}</InternalLink>;
    }
    return (
        <div className={classNames(styles.root, linkStyle)}>
            {renderIcon(icon)}
            {renderSubHeading(subHeading)}
            {link ? linkComponent : innerComponents}
        </div>
    );
};

/**
 * Check whether to render an icon configured by props
 * @param {Object} icon - the icon config object
 * @returns {Node|null} return a configured icon component or nothing
 */
const renderIcon = (icon) => {
    return (
        icon
        && (
            <div className={styles.icon}>
                <Icon variant={icon.variant} color={icon.color} size={icon.size} />
            </div>
        )
    );
};

/**
 * Check whether to render a subtitle configured by props
 * @param {String} subHeading - the subTitle string
 * @returns {Node|null} return a configured subTitle component or nothing
 */
const renderSubHeading = (subHeading) => {
    return subHeading ? <>{subHeading}</> : null;
};

SnapshotItem.propTypes = {
    visualProps: PropTypes.shape({
        icon: PropTypes.object
    }),
    contentProps: PropTypes.shape({
        value: PropTypes.string.isRequired,
        // Snapshot items without titles are allowed - this is required in HNC
        title: PropTypes.string,
        subHeading: PropTypes.string,
        separator: PropTypes.string,
        link: PropTypes.string
    })
};
SnapshotItem.defaultProps = {
    visualProps: {}
};

export { SnapshotItem };
